import React from 'react';

interface BatchContinueButtonProps {
  onClick: () => void;
  disabled: boolean;
  estimatedCost: number;
  processableRows: number;
  selectedProcessingType: string;
}

export const BatchContinueButton: React.FC<BatchContinueButtonProps> = ({
  onClick,
  disabled,
  estimatedCost,
  processableRows,
  selectedProcessingType,
}) => {
  return (
    <div className="text-center">
      <button
        className={`ca-btn ca-btn--primary ${
          disabled ? 'cursor-not-allowed opacity-50' : ''
        }`}
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
      >
        Continue to Processing
      </button>
      {!disabled && processableRows > 0 && (
        <p className="mt-2 text-sm text-slate-600">
          Estimated cost: ${estimatedCost.toFixed(2)} for {processableRows.toLocaleString()} records
        </p>
      )}
    </div>
  );
};
